<template>
  <div class="content">
    <!-- <header>
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>提交成功</p>
    </header> -->
    <div class="cont">
      <i class="iconfont icon-jinduquerentubiao success"></i>
      <p>成功提交入驻申请</p>
      <p>平台将1-3个工作日内联系你</p>
      <van-button type="info" class="btn return" @click="goto">进入悦买逛逛</van-button>
      <span class="texts">到应用市场下载“悦卖app”，查看审核结果吧~</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goto() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            wx.miniProgram.switchTab({
              url: "/pages/bazaarIndex/bazaarIndex"
            });
          } else {
            //非小程序环境下逻辑
          }
        });
      }
    },
    // returnBack(){
    //   this.$router.push({
    //     path: "/joinup",
    //     query: {
    //       type: this.GetQueryString("type"),
    //       refereeId: this.GetQueryString("refereeId")
    //     }
    //   }); //跳转
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
  // header {
  //   display: flex;
  //   align-items: center;
  //   height: 44px;
  //   i {
  //     font-size: 26px;
  //   }
  //   p {
  //     font-size: 18px;
  //     margin-left: 120px;
  //   }
  // }
  .cont {
    p {
      font-size: 16px;
      text-align: center;
      line-height: 16px;
    }
    .success {
      display: block;
      font-size: 88px;
      color: #4ecb74;
      margin: 104px auto 32px;
    }

    .btn {
      width: 231px;
      height: 44px;
      border-radius: 25px;
    }
    .return {
      margin: 40px auto 21px;
    }
    .texts {
      display: block;
      font-size: 14px;
      color: #1993ff;
      text-align: center;
    }
  }
}
</style>
